export default __webpack_public_path__ + "static/media/fam6.4d56bc2f.png";